import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "flex md:flex-row items-center md:space-y-0 space-y-2 flex-col md:space-x-4"
}
const _hoisted_4 = { class: "text-muted" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-base material-icons" }, "reviews", -1)
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "mr-2 text-base material-icons" }, "reviews", -1)
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExerciseSolution = _resolveComponent("ExerciseSolution")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ExerciseSolutionEditor = _resolveComponent("ExerciseSolutionEditor")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showTitle)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_ctx.$t("exercise_solution.proposed_solutions_title")), 1))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownSolutions, (solution) => {
      return (_openBlock(), _createBlock(_component_ExerciseSolution, {
        class: "w-full my-4",
        publishing: _ctx.publishing,
        key: 'e-' + _ctx.exercise.id + '-solution-' + solution.id,
        solution: solution,
        exercise: _ctx.exercise,
        forceExpanded: _ctx.standalone,
        showTeacherControls: _ctx.showTeacherControls,
        onUpdateState: ($event: any) => (_ctx.onSolutionStateUpdate(solution, $event)),
        onEditSolution: ($event: any) => (_ctx.onEditSolution(solution)),
        onDeleteSolution: ($event: any) => (_ctx.onDeleteSolution(solution))
      }, null, 8, ["publishing", "solution", "exercise", "forceExpanded", "showTeacherControls", "onUpdateState", "onEditSolution", "onDeleteSolution"]))
    }), 128)),
    (_ctx.solutions.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("exercise_solution.no_solutions_call_to_action")), 1),
          _createVNode(_component_Btn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAddSolution())),
            variant: 'primary',
            class: "w-full md:w-max",
            size: 'sm',
            outline: true
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("exercise_solution.propose_solution")), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.canShowMore)
        ? (_openBlock(), _createBlock(_component_Btn, {
            key: 0,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onShowMore())),
            size: 'xs',
            variant: 'primary-borderless',
            class: "mr-auto -ml-1"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("exercise_solution.load_more_solutions")) + " ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.solutions.length > 0 && _ctx.allowAddSolution)
        ? (_openBlock(), _createBlock(_component_Btn, {
            key: 1,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAddSolution())),
            variant: 'primary',
            class: "mt-4 md:mr-auto w-full md:w-max",
            size: 'sm',
            outline: true
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("exercise_solution.propose_solution")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.showExerciseThreadLink && _ctx.solutions.length > 0)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: _ctx.threadPermalink,
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Btn, {
                size: 'xs',
                class: "-ml-1",
                variant: 'primary-borderless'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("exercise_solution.go_to_exercise_thread")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.editingSolutionId !== null || _ctx.editingSolutionDeepCopy !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_ExerciseSolutionEditor, {
            publishing: _ctx.publishing,
            saving: _ctx.saving,
            savingError: _ctx.savingError,
            modelValue: _ctx.editingSolution ?? _ctx.editingSolutionDeepCopy,
            onUpdateSolution: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDraftSolutionChange($event.key, $event.value))),
            onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClose())),
            editorType: _ctx.solutionType,
            exercise: _ctx.exercise
          }, null, 8, ["publishing", "saving", "savingError", "modelValue", "editorType", "exercise"])
        ]))
      : _createCommentVNode("", true)
  ]))
}